import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

import { setMetadataType } from '../../../store/actions/metadata.actions';

const ruleTypes = ['System', 'Shipped', 'User', 'Skip'];

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: (48 * 4.5) + 8,
      width: 250,
    },
  },
};

const styles = () => ({
  formControl: {
    minWidth: 120,
  },
});

class RuleTypeContainer extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.setMetadataType(this.props.column.key, event.target.value);
  }

  // eslint-disable-next-line class-methods-use-this
  renderRuleTypes() {
    return ruleTypes.map(name => (
      <MenuItem
        key={name}
        value={name}
      >
        {name}
      </MenuItem>
    ));
  }

  render() {
    const { classes, column } = this.props;
    return (
      <FormControl className={classes.formControl}>
        <Select
          onChange={e => this.handleChange(e)}
          MenuProps={MenuProps}
          value={column.type}
        >
          {this.renderRuleTypes()}
        </Select>
      </FormControl>
    );
  }
}

RuleTypeContainer.propTypes = {
  column: PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  setMetadataType: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(connect(null, { setMetadataType })(RuleTypeContainer));
